import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent } from "@/components/ui/card";
import { Lock, Tv } from "lucide-react";
import { toast } from "sonner";
import { login } from "@/lib/api";

export function LoginPage({ onLoggedIn }) {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!password) return;
    setLoading(true);
    try {
      await login(password);
      toast.success("Welcome back");
      onLoggedIn();
    } catch (err) {
      toast.error(
        err?.response?.status === 401
          ? "Incorrect password"
          : "Unable to sign in"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="glass-card w-full max-w-sm" data-testid="login-card">
        <CardContent className="p-8">
          <div className="flex flex-col items-center mb-6">
            <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-primary to-accent flex items-center justify-center mb-3">
              <Tv className="w-7 h-7 text-primary-foreground" />
            </div>
            <h1 className="text-xl font-display font-bold text-foreground">
              New Logical Sports
            </h1>
            <p className="text-xs text-muted-foreground mt-1">
              Thumbnail Generator
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-1.5">
              <Label htmlFor="password" className="text-xs flex items-center gap-1">
                <Lock className="w-3 h-3" />
                Password
              </Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password"
                autoFocus
                data-testid="login-password-input"
              />
            </div>
            <Button
              type="submit"
              variant="premium"
              className="w-full"
              disabled={loading}
              data-testid="login-submit-button"
            >
              {loading ? "Signing in..." : "Sign In"}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
